module.exports = function getSiteMetaData(nodesConfig) {
	const siteMetaSchema = {
		title: { env: "CLF_SITE_TITLE", default: "New Gatsby Site" },
		subtitle: { env: "CLF_SITE_SUBTITLE", default: "" },
		titleAsText: { env: "CLF_SITE_TITLE_AS_TEXT", default: false, type: "boolean" },
		hasSearch: { env: "CLF_HAS_SEARCH", default: false, type: "boolean" },
		hasCart: { env: "CLF_HAS_CART", default: false, type: "boolean" },
		cartRoute: { env: "CLF_CART_ROUTE", default: "/cart" },
		designSystem: { env: "CLF_DESIGN_SYSTEM", default: "material" },
		description: { env: "CLF_SITE_DESCRIPTION", default: "" },
		url: { env: "CLF_SITE_URL", default: "http://localhost:8000" },
		siteUrl: { env: "CLF_SITE_URL", default: "http://localhost:8000" },
		drupalUrl: { env: "CLF_BACKEND_URL", default: "" },
		privateRoute: { env: "CLF_PRIVATE_ROUTE", default: "" },
		adminEmail: { env: "CLF_EMAIL", default: "" },
		allowRegistration: { env: "CLF_ALLOW_REGISTRATION", default: false, type: "boolean" },
		twitterUsername: { env: "CLF_TWITTER_HANDLE", default: "" },
		facebookUrl: { env: "CLF_FACEBOOK_URL", default: "" },
		linkedInUrl: { env: "CLF_LINKEDIN_URL", default: "" },
		instagramUrl: { env: "CLF_INSTAGRAM_URL", default: "" },
		youtubeUrl: { env: "CLF_YOUTUBE_URL", default: "" },
		accentColor: { env: "CLF_ACCENT_COLOR", default: "#000000" },
		colophonText: { env: "CLF_COLOPHON_TEXT", default: "All Rights Reserved" },
	};
	let siteMetadata = {
		apiBase: "jsonapi",
		menus: [],
		nodesConfig: {},
	};

	if (process.env.CLF_MENUS && process.env.CLF_MENUS.length > 0) {
		siteMetadata.menus = process.env.CLF_MENUS.split("|");
	}

	if (nodesConfig) {
		siteMetadata.nodesConfig = nodesConfig;
	}

	for (const [key, conf] of Object.entries(siteMetaSchema)) {
		if (process.env[conf.env]) {
			if (conf.type === "boolean") {
				siteMetadata[key] =
					process.env[conf.env] === "1" || process.env[conf.env] === "true"
						? true
						: false;
			} else {
				siteMetadata[key] = process.env[conf.env];
			}
		} else {
			siteMetadata[key] = conf.default;
		}
	}

	siteMetadata.titleTemplate = `%s · ${siteMetadata.title}`;
	siteMetadata.image = `${siteMetadata.url}/og.jpg`;
	siteMetadata.apiBaseUrl = `${siteMetadata.drupalUrl}/${siteMetadata.apiBase}`;
	return siteMetadata;
};
